(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow-max10"] && !Shopify.designMode) return;
  try {
    
 $(window).scroll(function (){
    $('.fadein').each(function(){
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll > position - windowHeight + 200){
          $(this).addClass('active');
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-about"] && !Shopify.designMode) return;
  try {
    
 $(window).scroll(function (){
  var scroll = $(window).scrollTop();
  if (window.innerWidth > 767) {
    if(scroll >= 1200){
      $('.fixed-video').addClass('DownMove');
    } else if(scroll <= 20){
      $('.fixed-video').removeClass('DownMove');
    } else{
        $('.fixed-video').removeClass('DownMove');
    }
  } else {
    if(scroll >= 500){
      $('.fixed-video').addClass('DownMove');
    } else if(scroll <= 20){
      $('.fixed-video').removeClass('DownMove');
    } else{
        $('.fixed-video').removeClass('DownMove');
    }
  }
});
$(function(){
  $('.fadein').each(function(i){
    let delay = 200;
    $(this).delay(i * delay).queue(function(next){
        $(this).addClass('active');
        next();
    });
  });
});
$(function(){
  $('.video-control').on('click', function(){
    $(this).attr('controls', 'controls');
  });
});

  } catch(e) { console.error(e); }
})();
})();
